// @ts-nocheck

import CommonApi from './../commonApi';
import { downloadRequestWithToken } from './';
const pddTestResult = new CommonApi('pddTestResult', 'Результаты ПДД');
export const printExam = async date => {
  const print = await downloadRequestWithToken(`/pddTestResult/pddExamTestsResults/print`, {
    date
  });
  if (print) return print;
  throw new Error('Не удалось распечатать');
};
export const printTraining = async date => {
  const print = await downloadRequestWithToken(`/pddTestResult/pddTrainingTestsResults/print`, {
    date
  });
  if (print) return print;
  throw new Error('Не удалось распечатать');
};
export default {
  ...pddTestResult,
  printExam,
  printTraining
};
